import { call, put, takeLatest } from "redux-saga/effects";
import {
  getVesselMastersListApi,
  addVesselMastersListApi,
  getVesselTypeMastersListApi,
  addVesselTypeMastersListApi,
  updateVesselTypeMastersListApi,
  getChecklistMastersListApi,
  getChecklistTypeMastersListApi,
  getDepartmentMastersListApi,
  addChecklistTypeMastersListApi,
  deleteChecklistTypeMastersListApi,
  getRoleMastersListApi,
  getScreenAccessMastersListApi,
  addRoleMastersListApi,
  deleteRoleMastersListApi,
  updateRoleMastersListApi,
  getRolePermissionMastersListApi,
  getCompanyListApi,
  addScreenAccessMastersListApi,
  updateScreenAccessMastersListApi,
  deleteScreenAccessMastersListApi,
  addRolePermissionMastersListApi,
  deleteRolePermissionMastersListApi,
  getUserMasterListApi,
  addNewDepartMentAPI,
  deleteDepartMentAPI,
  addUserMasterListApi,
  deleteUserMasterListApi,
  updateUserMasterListApi,
  updateChecklistTypeMastersListApi,
  addChecklistMastersListApi,
  addQuetionChecklistMastersListApi,
  deleteChecklistMastersListApi,
  getQuetionChecklistMastersListApi,
  updateChecklistMastersListApi,
  updateQuetionChecklistMastersListApi,
  updateDepartmentMastersListApi,
  addQuestionMastersListApi,
  updateQuestionMastersListApi,
  getQuetionChecklistMasterApi,
  deleteChecklistQuestionAPI,
  deleteVesselTypeMastersListApi,
  getAllQuetionChecklistMastersListApi,
  updateVesselMastersListApi,
  deleteVesselMastersListApi,
  updateRolePermissionMastersListApi,
  getSendNotificationMastersListApi,
  addSendNotificationMastersListApi,
  getSupportMastersListApi,
} from "../requests/mastersRequests";
import { toast } from "react-toastify";
import { MastersActions } from "../../action-types/mastersActionTypes";
import {
  setVesselMasterList,
  setVesselTypeMasterList,
  setChecklistMastersList,
  setChecklistTypeMastersList,
  setDepartmentMasterList,
  setRoleMasterList,
  setScreenAccessMasterList,
  setRolePermissionMasterList,
  setCompanyList,
  setUserMasterList,
  getDepartmentMasterList,
  setIsOpenModelAddDepartmentMaster,
  getRolePermissionMasterList,
  addQuestionChecklistMastersList,
  setQuestionChecklistMastersList,
  updateQuestionChecklistMastersList,
  setIsOpenModelAddUserMaster,
  setIsOpenModelEditUserMaster,
  setIsOpenModelEditDepartmentMaster,
  setIsOpenModelAddQuestionMaster,
  setIsOpenModelEditQuestionMaster,
  setChecklistQuestionMasterList,
  getChecklistMastersList,
  getVesselTypeMasterList,
  getVesselMasterList,
  setAllQuestionChecklistMastersList,
  setIsOpenModelAddChecklistTypeMaster,
  setIsOpenModelEditChecklistTypeMaster,
  setPaginationForMaster,
  setChecklistQuestionMasterPagination,
  setChecklistTypeMasterPagination,
  setChecklistMasterPagination,
  setVesselMasterPagination,
  setVesselTypeMasterPagination,
  setIsOpenModelAddVesselTypeMaster,
  setIsOpenModelEditVesselTypeMaster,
  setIsOpenModelAddVesselMaster,
  setIsOpenModelEditVesselMaster,
  setSendNotificationMasterList,
  setIsOpenModelAddSendNotificationMaster,
  setSupportMasterList,
} from "../../actions/mastersAction";
import { setLoader, setLoaderSaveButton } from "../../actions/userActions";

// Vessel Master Handler

function* getVesselMastersHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(getVesselMastersListApi, action.payload);
    if (data.status) {
      yield put(setVesselMasterList(data.data));
      yield put(setVesselMasterPagination(data?.pagination));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function* addVesselMastersHandler(action) {
  yield put(setLoaderSaveButton(true));
  // start loader here
  try {
    const { data } = yield call(addVesselMastersListApi, action.payload);

    if (data.status) {
      yield put(setLoaderSaveButton(false));
      toast.success(data.message);
      setTimeout(() => {
        setIsOpenModelAddVesselMaster(false);
        window.location.reload();
      }, 1000);
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    yield put(setIsOpenModelAddVesselMaster(true));
    yield put(setLoaderSaveButton(false));
    toast.error(error.response.data.message);

    // handle error
  } finally {
    //stop loader here
  }
}

function* updateVesselMastersHandler(action) {
  yield put(setLoaderSaveButton(true));
  yield put(setLoader(true));
  // start loader here
  try {
    const { data } = yield call(updateVesselMastersListApi, action.payload);

    if (data.status) {
      // yield put(
      //   getVesselMasterList({
      //     active: "true",
      //     searchByFirstName: "",
      //   })
      // );
      const payload2 = {
        isOpenEditModel: false,
        EditRowDataModel: action.payload,
      };
      yield put(setLoaderSaveButton(false));
      toast.success(data.message);
      setTimeout(() => {
        setIsOpenModelEditVesselMaster(payload2);
        window.location.reload();
        setLoader(false);
      }, 1000);
    } else {
      toast.error(data.response.data.message);
      yield put(setLoaderSaveButton(false));
      const payload = {
        isOpenEditModel: true,
        EditRowDataModel: action.payload,
      };
      yield put(setIsOpenModelEditVesselMaster(payload));
      yield put(setLoader(false)); // handle error
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    yield put(setLoaderSaveButton(false));
    const payload = {
      isOpenEditModel: true,
      EditRowDataModel: action.payload,
    };
    yield put(setIsOpenModelEditVesselMaster(payload));
    yield put(setLoader(false)); // handle error
  } finally {
    //stop loader here
  }
}

function* deleteVesselMastersHandler(action) {
  yield put(setLoader(true));
  // start loader here
  try {
    const { data } = yield call(deleteVesselMastersListApi, action.payload.id);

    if (data.status) {
      toast.success(data.message);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    yield put(setLoader(false));
    // handle error
  } finally {
    //stop loader here
  }
}

// Vessel Type Master Handler

function* getVesselTypeMastersHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(getVesselTypeMastersListApi, action.payload);
    if (data?.response?.status) {
      yield put(setVesselTypeMasterList(data?.response?.data));
      yield put(setVesselTypeMasterPagination(data?.response?.pagination));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function* addVesselTypeMastersHandler(action) {
  yield put(setLoaderSaveButton(true));
  // start loader here
  try {
    const { data } = yield call(addVesselTypeMastersListApi, action.payload);

    if (data.status) {
      yield put(setLoaderSaveButton(false));
      toast.success(data.message);
      setTimeout(() => {
        setIsOpenModelAddVesselTypeMaster(false);
        window.location.reload();
      }, 1000);
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    yield put(setIsOpenModelAddVesselTypeMaster(true));
    yield put(setLoaderSaveButton(false));
    toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function* updateVesselTypeMastersHandler(action) {
  yield put(setLoaderSaveButton(true));
  yield put(setLoader(true));
  // start loader here
  try {
    const { data } = yield call(updateVesselTypeMastersListApi, action.payload);

    if (data.response.status) {
      // yield put(
      //   getVesselTypeMasterList({
      //     active: "true",
      //     searchByFirstName: "",
      //   })
      // );
      const payload2 = {
        isOpenEditModel: false,
        EditRowDataModel: action.payload,
      };
      yield put(setLoaderSaveButton(false));
      toast.success(data.response.message);
      setTimeout(() => {
        setIsOpenModelEditVesselTypeMaster(payload2);
        window.location.reload();
        setLoader(false);
      }, 1000);
    } else {
      toast.error(data.response.message);
      yield put(setLoaderSaveButton(false));
      const payload = {
        isOpenEditModel: true,
        EditRowDataModel: action.payload,
      };
      yield put(setIsOpenModelEditVesselTypeMaster(payload));
      yield put(setLoader(false)); // handle error
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    yield put(setLoaderSaveButton(false));
    const payload = {
      isOpenEditModel: true,
      EditRowDataModel: action.payload,
    };
    yield put(setIsOpenModelEditVesselTypeMaster(payload));
    yield put(setLoader(false)); // handle error
    // handle error
  } finally {
    //stop loader here
  }
}

function* deleteVesselTypeMastersHandler(action) {
  yield put(setLoader(true));
  // start loader here
  try {
    const { data } = yield call(
      deleteVesselTypeMastersListApi,
      action.payload.id
    );

    if (data.status) {
      toast.success(data.message);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    yield put(setLoader(false));

    // handle error
  } finally {
    //stop loader here
  }
}

// Checklist Master and Checklist Question Handler

function* getChecklistMastersHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(getChecklistMastersListApi, action.payload);
    if (data.status) {
      yield put(setChecklistMastersList(data.data));
      yield put(setChecklistMasterPagination(data?.pagination));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function* addChecklistMastersHandler(action) {
  yield put(setLoader(true));
  // start loader here
  try {
    const { data } = yield call(addChecklistMastersListApi, action.payload);

    if (data.status) {
      toast.success(data.message);

      for (const row of action.payload.selectedQuestion) {
        const payload = {
          checklist_id: data?.data?.id,
          question: row?.question,
        };
        yield put(addQuestionChecklistMastersList(payload));
      }
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    yield put(setLoader(false));
    // handle error
  } finally {
    //stop loader here
    // yield put(setLoader(false));
  }
}

function* updateChecklistMastersHandler(action) {
  yield put(setLoader(true));
  // start loader here
  try {
    const { data } = yield call(updateChecklistMastersListApi, action.payload);

    if (data.status) {
      // toast.success(data.message);
      const jsonString = localStorage.getItem("PrevSelectedData");
      const PrevSelectedData = JSON.parse(jsonString);

      for (const row of action.payload.selectedQuestion) {
        const isselectedQuestion = PrevSelectedData.find(
          (isselectedrow) => isselectedrow?.id === row?.id
        );
        if (isselectedQuestion) {
          const payload = {
            checklist_id: data?.data?.id,
            question: row?.question,
            id: row?.id,
          };
          yield put(updateQuestionChecklistMastersList(payload));
        } else {
          const payload = {
            checklist_id: data?.data?.id,
            question: row?.question,
          };
          yield put(addQuestionChecklistMastersList(payload));
        }
      }
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    yield put(setLoader(false));
    // handle error
  } finally {
    //stop loader here
    // yield put(setLoader(false));
  }
}

function* deleteChecklistMastersHandler(action) {
  yield put(setLoader(true));
  // start loader here
  try {
    const { data } = yield call(
      deleteChecklistMastersListApi,
      action.payload.id
    );

    if (data.status) {
      toast.success(data.message);
      yield put(
        getChecklistMastersList({
          checklist_type: "Daily",
          limit: 10,
          offset: 0,
        })
      );
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    yield put(setLoader(false));
    // handle error
  } finally {
    //stop loader here
    // yield put(setLoader(false));
  }
}

function* getQuetionChecklistMastersHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(
      getQuetionChecklistMastersListApi,
      action.payload.id
    );
    if (data.status) {
      yield put(setQuestionChecklistMastersList(data.data));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    yield put(setLoader(false));
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function* addQuetionChecklistMastersHandler(action) {
  yield put(setLoader(true));
  // start loader here
  try {
    const { data } = yield call(
      addQuetionChecklistMastersListApi,
      action.payload
    );
    if (data.status) {
      yield put(
        getChecklistMastersList({
          checklist_type: "Daily",
          limit: 10,
          offset: 0,
        })
      );
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    yield put(setLoader(false));
    // handle error
  } finally {
    //stop loader here
    // yield put(setLoader(false));
  }
}

function* updateQuetionChecklistMastersHandler(action) {
  yield put(setLoader(true));
  // start loader here
  try {
    const { data } = yield call(
      updateQuetionChecklistMastersListApi,
      action.payload
    );

    if (data.status) {
      toast.success(data.message);
      yield put(
        getChecklistMastersList({
          checklist_type: "Daily",
          limit: 10,
          offset: 0,
        })
      );
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function* getAllQuetionChecklistMastersHandler(action) {
  // start loader here
  // yield put(setLoader(true));
  try {
    const { data } = yield call(
      getAllQuetionChecklistMastersListApi,
      action.payload
    );
    if (data.status) {
      yield put(setAllQuestionChecklistMastersList(data.data));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

// Checklist Type Master Handler

function* getChecklistTypeMastersHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(getChecklistTypeMastersListApi, action.payload);
    if (data.status) {
      yield put(setChecklistTypeMastersList(data.data));
      yield put(setChecklistTypeMasterPagination(data?.pagination));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function* addChecklistTypeMastersHandler(action) {
  yield put(setLoaderSaveButton(true));
  // start loader here
  try {
    const { data } = yield call(addChecklistTypeMastersListApi, action.payload);

    if (data.status) {
      yield put(setIsOpenModelAddChecklistTypeMaster(false));
      yield put(setLoaderSaveButton(false));
      toast.success(data.message);
      yield put({
        type: MastersActions.GET_CHECKLIST_TYPE_MASTERS_LIST,
      });
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    yield put(setIsOpenModelAddChecklistTypeMaster(true));
    yield put(setLoaderSaveButton(false));
    toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    // yield put(setLoader(false));
  }
}

function* updateChecklistTypeMastersHandler(action) {
  yield put(setLoaderSaveButton(true));
  // start loader here
  try {
    const { data } = yield call(
      updateChecklistTypeMastersListApi,
      action.payload
    );

    if (data.status) {
      yield put(setLoaderSaveButton(false));
      toast.success(data.message);
      yield put({
        type: MastersActions.GET_CHECKLIST_TYPE_MASTERS_LIST,
      });
      const payload = {
        isOpenEditModel: false,
      };
      yield put(setIsOpenModelEditChecklistTypeMaster(payload));
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    yield put(setLoaderSaveButton(false));
    const payload = {
      isOpenEditModel: true,
      EditRowDataModel: action.payload,
    };
    yield put(setIsOpenModelEditChecklistTypeMaster(payload));
    // handle error
  } finally {
    //stop loader here
    // yield put(setLoader(false));
  }
}

function* deleteChecklistTypeMastersHandler(action) {
  yield put(setLoader(true));
  // start loader here
  try {
    const { data } = yield call(
      deleteChecklistTypeMastersListApi,
      action.payload.id
    );

    if (data.status) {
      toast.success(data.message);
      yield put({
        type: MastersActions.GET_CHECKLIST_TYPE_MASTERS_LIST,
      });
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    yield put(setLoader(false));
    // handle error
  } finally {
    //stop loader here
    // yield put(setLoader(false));
  }
}

// Role Master Handler

function* getRoleMastersHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(getRoleMastersListApi);
    if (data.status) {
      const filteredCompanyAdmin = data.data.filter(
        (row) => row?.name === "COMPANY_ADMIN"
      );
      localStorage.setItem("CompanyAdminID", filteredCompanyAdmin[0]?.id);

      const filteredManagement = data.data.filter(
        (row) => row?.name === "MANAGEMENT"
      );
      localStorage.setItem("ManagementID", filteredManagement[0]?.id);

      const filteredVessalAdmin = data.data.filter(
        (row) => row?.name === "VESSEL_ADMIN"
      );
      localStorage.setItem("VessalAdminID", filteredVessalAdmin[0]?.id);

      const filteredSuperintendent = data.data.filter(
        (row) => row?.name === "SUPERINTENDENT"
      );
      localStorage.setItem("SuperintendentID", filteredSuperintendent[0]?.id);

      const dataString = JSON.stringify(data.data);
      localStorage.setItem("roleMastersData", dataString);

      yield put(setRoleMasterList(data.data));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function* addRoleMastersHandler(action) {
  yield put(setLoader(true));
  // start loader here
  try {
    const { data } = yield call(addRoleMastersListApi, action.payload);

    if (data.status) {
      toast.success(data.message);
      yield put({
        type: MastersActions.GET_ROLE_MASTER_LIST,
      });
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    yield put(setLoader(false));
    // handle error
  } finally {
    //stop loader here
    // yield put(setLoader(false));
  }
}

function* deleteRoleMastersHandler(action) {
  // yield put(setLoader(true));
  // start loader here
  try {
    const { data } = yield call(deleteRoleMastersListApi, action.payload.id);

    if (data.status) {
      toast.success(data.message);
      yield put({
        type: MastersActions.GET_ROLE_MASTER_LIST,
      });
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    yield put(setLoader(false));
    // handle error
  } finally {
    //stop loader here
    // yield put(setLoader(false));
  }
}

function* updateRoleMastersHandler(action) {
  yield put(setLoader(true));
  // start loader here
  try {
    const { data } = yield call(updateRoleMastersListApi, action.payload);

    if (data.status) {
      toast.success(data.message);
      yield put({
        type: MastersActions.GET_ROLE_MASTER_LIST,
      });
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    yield put(setLoader(false));
    // handle error
  } finally {
    //stop loader here
    // yield put(setLoader(false));
  }
}

// Screen Access Master Handler

function* getScreenAccessMastersHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(getScreenAccessMastersListApi);
    if (data.status) {
      yield put(setScreenAccessMasterList(data.data));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function* addScreenAccessMastersHandler(action) {
  yield put(setLoader(true));
  // start loader here
  try {
    const { data } = yield call(addScreenAccessMastersListApi, action.payload);

    if (data.status) {
      toast.success(data.message);
      yield put({
        type: MastersActions.GET_SCREEN_ACCESS_MASTER_LIST,
      });
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    // yield put(setLoader(false));
  }
}

function* updateScreenAccessMastersHandler(action) {
  yield put(setLoader(true));
  // start loader here
  try {
    const { data } = yield call(
      updateScreenAccessMastersListApi,
      action.payload
    );

    if (data.status) {
      toast.success(data.message);
      yield put({
        type: MastersActions.GET_SCREEN_ACCESS_MASTER_LIST,
      });
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    // yield put(setLoader(false));
  }
}

function* deleteScreenAccessMastersHandler(action) {
  yield put(setLoader(true));
  // start loader here
  try {
    const { data } = yield call(
      deleteScreenAccessMastersListApi,
      action.payload.id
    );

    if (data.status) {
      toast.success(data.message);
      yield put({
        type: MastersActions.GET_SCREEN_ACCESS_MASTER_LIST,
      });
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    // yield put(setLoader(false));
  }
}

// Role Permission Master Handler

function* getRolePermissionMastersHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(
      getRolePermissionMastersListApi,
      action.payload
    );
    if (data.status) {
      yield put(setRolePermissionMasterList(data.data));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function* addRolePermissionMastersHandler(action) {
  yield put(setLoader(true));
  // start loader here
  try {
    const { data } = yield call(
      addRolePermissionMastersListApi,
      action.payload
    );

    if (data.status) {
      toast.success(data.message);
      const payload = {
        id: action.payload.role_id,
      };
      yield put(getRolePermissionMasterList(payload));
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    // yield put(setLoader(false));
  }
}

function* deleteRolePermissionMastersHandler(action) {
  yield put(setLoader(true));
  // start loader here
  try {
    const { data } = yield call(
      deleteRolePermissionMastersListApi,
      action.payload.id
    );

    if (data.status) {
      toast.success(data.message);
      const payload = {
        id: action.payload.role_id,
      };
      yield put(getRolePermissionMasterList(payload));
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    // yield put(setLoader(false));
  }
}

function* updateRolePermissionMastersHandler(action) {
  yield put(setLoader(true));
  // start loader here
  try {
    const { data } = yield call(
      updateRolePermissionMastersListApi,
      action.payload
    );

    if (data.status) {
      toast.success(data.message);
      const payload = {
        id: action.payload.role_id,
      };
      yield put(getRolePermissionMasterList(payload));
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    // yield put(setLoader(false));
  }
}

// Company Handler

function* getCompanyHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(getCompanyListApi, action.payload);
    // if (data.status) {
    yield put(setCompanyList(data));
    // } else {
    //   yield toast.error(data.message);
    // }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

// User Master Handler (Company Admin Master,Management Master,Vessel Admin Master,Superintendent Master)

function* getUserMasterHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(getUserMasterListApi, action.payload);
    if (data.status) {
      yield put(setUserMasterList(data?.data));
      yield put(setPaginationForMaster(data?.pagination));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function* addUserMasterHandler(action) {
  // start loader here
  yield put(setLoaderSaveButton(true));
  try {
    const { data } = yield call(addUserMasterListApi, action.payload);
    if (data.status) {
      const companyID = localStorage.getItem("companyID");
      // const payload = {
      //   roleId: action.payload.role_id,
      //   companyId: companyID,
      //   active: "true",
      //   searchByVesselId: "",
      //   searchByFirstName: "",
      // };
      // yield put(getUserMasterList(payload));
      yield put(setLoaderSaveButton(false));
      toast.success(data.message);
      setTimeout(() => {
        setIsOpenModelAddUserMaster(false);
        window.location.reload();
      }, 1000);
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    yield put(setIsOpenModelAddUserMaster(true));
    yield put(setLoaderSaveButton(false));
    toast.error(error.response.data.message);

    // handle error
  } finally {
    //stop loader here
    // yield put(setLoader(false));
  }
}

function* updateUserMasterHandler(action) {
  // start loader here
  yield put(setLoaderSaveButton(true));
  yield put(setLoader(true));

  try {
    const { data } = yield call(updateUserMasterListApi, action.payload);

    if (data.status) {
      const companyID = localStorage.getItem("companyID");
      // const payload = {
      //   roleId: action.payload.role_id,
      //   companyId: companyID,
      //   active: "true",
      //   searchByVesselId: "",
      //   searchByFirstName: "",
      // };
      // yield put(getUserMasterList(payload));
      const payload2 = {
        isOpenEditModel: false,
        EditRowDataModel: action.payload,
      };
      yield put(setLoaderSaveButton(false));
      toast.success(data.message);
      setTimeout(() => {
        setIsOpenModelEditUserMaster(payload2);
        window.location.reload();
        setLoader(false);
      }, 1000);
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    yield put(setLoaderSaveButton(false));
    const payload = {
      isOpenEditModel: true,
      EditRowDataModel: action.payload,
    };
    yield put(setIsOpenModelEditUserMaster(payload));
    yield put(setLoader(false));
    // handle error
  } finally {
    //stop loader here
  }
}

function* deleteUserMasterHandler(action) {
  yield put(setLoader(true));
  // start loader here
  try {
    const { data } = yield call(deleteUserMasterListApi, action.payload.id);
    if (data.status) {
      // const companyID = localStorage.getItem("companyID");
      // const payload = {
      //   roleId: action.payload.roleId,
      //   companyId: companyID,
      //   active: "true",
      //   searchByVesselId: "",
      //   searchByFirstName: "",
      // };
      // yield put(getUserMasterList(payload));
      toast.success(data.message);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    yield put(setLoader(false));
    // handle error
  } finally {
    //stop loader here
    // yield put(setLoader(false));
  }
}

// Department Master Handler

function* getDepartmentMastersHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(getDepartmentMastersListApi, action?.payload);
    if (data.status) {
      yield put(setDepartmentMasterList(data.data));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function* addNewDepartmentHandler(action) {
  try {
    const { data } = yield call(addNewDepartMentAPI, action.payload);
    if (data.status) {
      const CompanyID = localStorage.getItem("companyID");

      yield put(
        getDepartmentMasterList({
          companyId: CompanyID,
        })
      );
      yield put(setIsOpenModelAddDepartmentMaster(false));
      yield toast.success(data.message);
    } else {
      yield put(setIsOpenModelAddDepartmentMaster(true));
      yield toast.error(data.message);
    }

    // handle response here and set into reducer
  } catch (error) {
    // yield put(setIsOpenModelAddDepartmentMaster(true))
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    // yield put(setIsOpenModelAddDepartmentMaster(true))
  }
}

function* deleteDepartmentHandler(action) {
  try {
    const { data } = yield call(deleteDepartMentAPI, action.payload);
    if (data.status) {
      const CompanyID = localStorage.getItem("companyID");

      yield put(
        getDepartmentMasterList({
          companyId: CompanyID,
        })
      );
      yield toast.success(data.message);
    } else {
      yield toast.error(data.message);
    }

    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
  }
}

function* updateDepartmentMastersHandler(action) {
  // start loader here
  try {
    const { data } = yield call(updateDepartmentMastersListApi, action.payload);

    if (data.status) {
      const CompanyID = localStorage.getItem("companyID");
      yield put(
        getDepartmentMasterList({
          companyId: CompanyID,
        })
      );
      const payload2 = {
        isOpenEditModel: false,
        EditRowDataModel: [],
      };
      yield put(setIsOpenModelEditDepartmentMaster(payload2));
      toast.success(data.message);
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    const payload = {
      isOpenEditModel: true,
    };
    yield put(setIsOpenModelEditDepartmentMaster(payload));
    // handle error
  } finally {
    //stop loader here
    // yield put(setLoader(false));
  }
}

// Checklist Question Master Handler

function* getChecklistQuestionMasterHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(getQuetionChecklistMasterApi, action?.payload);
    if (data.status) {
      yield put(setChecklistQuestionMasterList(data.data));
      yield put(setChecklistQuestionMasterPagination(data?.pagination));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function* addQuestionHandler(action) {
  yield put(setLoaderSaveButton(true));
  try {
    const { data } = yield call(addQuestionMastersListApi, action.payload);
    if (data.status) {
      // const CompanyID = localStorage.getItem("companyID");
      // yield put(
      //   getChecklistQuestionMasterList({
      //     companyId: CompanyID,
      //     searchByQuestion: "",
      //     checklist_type: "Daily",
      //     active: "true",
      //   })
      // );
      yield put(setLoaderSaveButton(false));
      yield toast.success(data.message);
      setTimeout(() => {
        setIsOpenModelAddQuestionMaster(false);
        window.location.reload();
      }, 1000);
    } else {
      yield put(setIsOpenModelAddQuestionMaster(true));
      yield toast.error(data.message);
      yield put(setLoaderSaveButton(false));
    }

    // handle response here and set into reducer
  } catch (error) {
    // yield put(setIsOpenModelAddDepartmentMaster(true))
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    // yield put(setIsOpenModelAddDepartmentMaster(true))
  }
}

function* updateQuestionHandler(action) {
  // start loader here
  yield put(setLoaderSaveButton(true));
  yield put(setLoader(true));

  try {
    const { data } = yield call(updateQuestionMastersListApi, action.payload);

    if (data.status) {
      // const CompanyID = localStorage.getItem("companyID");
      // yield put(
      //   getChecklistQuestionMasterList({
      //     companyId: CompanyID,
      //     searchByQuestion: "",
      //     checklist_type: "Daily",
      //     active: "true",
      //   })
      // );
      const payload2 = {
        isOpenEditModel: false,
        EditRowDataModel: [],
      };
      yield put(setLoaderSaveButton(false));
      toast.success(data.message);
      setTimeout(() => {
        setIsOpenModelEditQuestionMaster(payload2);
        window.location.reload();
        setLoader(false);
      }, 1000);
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    toast.error(error.response.data.message);
    const payload = {
      isOpenEditModel: true,
    };
    yield put(setIsOpenModelEditQuestionMaster(payload));
    yield put(setLoaderSaveButton(false));
    yield put(setLoader(false));

    // handle error
  } finally {
    //stop loader here
  }
}

function* deleteQuestionChecklistHandler(action) {
  try {
    const { data } = yield call(deleteChecklistQuestionAPI, action.payload?.id);
    if (data.status) {
      // const CompanyID = localStorage.getItem("companyID");
      // yield put(
      //   getChecklistQuestionMasterList({
      //     companyId: CompanyID,
      //     searchByQuestion: "",
      //     checklist_type: "Daily",
      //     active: "true",
      //   })
      // );
      yield toast.success(data.message);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      yield toast.error(data.message);
    }

    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
  }
}

// Send Notification Master Handler

function* getSendNotificationMastersHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(getSendNotificationMastersListApi);
    if (data.status) {
      yield put(setSendNotificationMasterList(data.data));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function* addSendNotificationMastersHandler(action) {
  yield put(setLoaderSaveButton(true));
  // start loader here
  try {
    const { data } = yield call(
      addSendNotificationMastersListApi,
      action.payload
    );

    if (data.status) {
      yield put(setLoaderSaveButton(false));
      toast.success(data.message);
      setTimeout(() => {
        setIsOpenModelAddSendNotificationMaster(false);
        window.location.reload();
      }, 1000);
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    yield put(setIsOpenModelAddSendNotificationMaster(true));
    yield put(setLoaderSaveButton(false));
    toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    // yield put(setLoader(false));
  }
}

// Support Master Handler

function* getSupportMastersHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(getSupportMastersListApi);
    if (data.status) {
      yield put(setSupportMasterList(data.data));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

// accountHandler Sagas
export default function* mastersSaga() {
  yield takeLatest(
    MastersActions.GET_VESSEL_MASTER_LIST,
    getVesselMastersHandler
  );
  yield takeLatest(
    MastersActions.UPDATE_VESSEL_MASTERS,
    updateVesselMastersHandler
  );
  yield takeLatest(
    MastersActions.DELETE_VESSEL_MASTERS,
    deleteVesselMastersHandler
  );
  yield takeLatest(MastersActions.ADD_VESSEL_MASTER, addVesselMastersHandler);
  yield takeLatest(
    MastersActions.GET_VESSEL_TYPE_MASTERS_LIST,
    getVesselTypeMastersHandler
  );
  yield takeLatest(
    MastersActions.ADD_VESSEL_TYPE_MASTERS,
    addVesselTypeMastersHandler
  );
  yield takeLatest(
    MastersActions.UPDATE_VESSEL_TYPE_MASTERS,
    updateVesselTypeMastersHandler
  );
  yield takeLatest(
    MastersActions.DELETE_VESSEL_TYPE_MASTERS,
    deleteVesselTypeMastersHandler
  );
  yield takeLatest(
    MastersActions.GET_CHECKLIST_MASTERS_LIST,
    getChecklistMastersHandler
  );
  yield takeLatest(
    MastersActions.ADD_CHECKLIST_MASTERS,
    addChecklistMastersHandler
  );
  yield takeLatest(
    MastersActions.DELETE_CHECKLIST_MASTERS,
    deleteChecklistMastersHandler
  );
  yield takeLatest(
    MastersActions.UPDATE_CHECKLIST_MASTERS,
    updateChecklistMastersHandler
  );
  yield takeLatest(
    MastersActions.UPDATE_CHECKLIST_QUESTION_MASTERS,
    updateQuetionChecklistMastersHandler
  );
  yield takeLatest(
    MastersActions.GET_CHECKLIST_QUESTION_MASTERS_LIST,
    getQuetionChecklistMastersHandler
  );
  yield takeLatest(
    MastersActions.GET_ALL_CHECKLIST_QUESTION_MASTERS_LIST,
    getAllQuetionChecklistMastersHandler
  );
  yield takeLatest(
    MastersActions.ADD_CHECKLIST_QUESTION_MASTERS,
    addQuetionChecklistMastersHandler
  );
  yield takeLatest(
    MastersActions.GET_CHECKLIST_TYPE_MASTERS_LIST,
    getChecklistTypeMastersHandler
  );
  yield takeLatest(
    MastersActions.UPDATE_CHECKLIST_TYPE_MASTERS,
    updateChecklistTypeMastersHandler
  );
  yield takeLatest(
    MastersActions.GET_DEPARTMENT_MASTER_LIST,
    getDepartmentMastersHandler
  );
  yield takeLatest(
    MastersActions.ADD_CHECKLIST_TYPE_MASTERS,
    addChecklistTypeMastersHandler
  );
  yield takeLatest(
    MastersActions.DELETE_CHECKLIST_TYPE_MASTERS,
    deleteChecklistTypeMastersHandler
  );
  yield takeLatest(MastersActions.GET_ROLE_MASTER_LIST, getRoleMastersHandler);
  yield takeLatest(
    MastersActions.GET_SCREEN_ACCESS_MASTER_LIST,
    getScreenAccessMastersHandler
  );
  yield takeLatest(MastersActions.ADD_ROLE_MASTER, addRoleMastersHandler);
  yield takeLatest(MastersActions.DELETE_ROLE_MASTER, deleteRoleMastersHandler);
  yield takeLatest(MastersActions.UPDATE_ROLE_MASTER, updateRoleMastersHandler);
  yield takeLatest(
    MastersActions.GET_ROLE_PERMISSION_MASTER_LIST,
    getRolePermissionMastersHandler
  );
  yield takeLatest(MastersActions.GET_COMPANY_LIST, getCompanyHandler);
  yield takeLatest(
    MastersActions.ADD_SCREEN_ACCESS_MASTER,
    addScreenAccessMastersHandler
  );
  yield takeLatest(
    MastersActions.UPDATE_SCREEN_ACCESS_MASTER,
    updateScreenAccessMastersHandler
  );
  yield takeLatest(
    MastersActions.DELETE_SCREEN_ACCESS_MASTER,
    deleteScreenAccessMastersHandler
  );
  yield takeLatest(
    MastersActions.ADD_ROLE_PERMISSION_MASTER,
    addRolePermissionMastersHandler
  );
  yield takeLatest(
    MastersActions.DELETE_ROLE_PERMISSION_MASTER,
    deleteRolePermissionMastersHandler
  );
  yield takeLatest(
    MastersActions.UPDATE_ROLE_PERMISSION_MASTER,
    updateRolePermissionMastersHandler
  );
  yield takeLatest(MastersActions.GET_USER_MASTER_LIST, getUserMasterHandler);
  yield takeLatest(MastersActions.ADD_USER_MASTER, addUserMasterHandler);
  yield takeLatest(MastersActions.UPDATE_USER_MASTER, updateUserMasterHandler);
  yield takeLatest(MastersActions.DELETE_USER_MASTER, deleteUserMasterHandler);
  yield takeLatest(MastersActions.ADD_NEW_DEPARTMENT, addNewDepartmentHandler);
  yield takeLatest(MastersActions.DELETE_DEPARTMENT, deleteDepartmentHandler);
  yield takeLatest(
    MastersActions.UPDATE_DEPARTMENT_MASTER,
    updateDepartmentMastersHandler
  );
  yield takeLatest(MastersActions.ADD_QUESTION_MASTER, addQuestionHandler);
  yield takeLatest(
    MastersActions.UPDATE_QUESTION_MASTER,
    updateQuestionHandler
  );
  yield takeLatest(
    MastersActions.GET_QUESTION_CHECKLIST_MASTER_LIST,
    getChecklistQuestionMasterHandler
  );
  yield takeLatest(
    MastersActions.DELETE_QUESTION_CHECKLIST_MASTER,
    deleteQuestionChecklistHandler
  );
  yield takeLatest(
    MastersActions.GET_SEND_NOTIFICATION_MASTER_LIST,
    getSendNotificationMastersHandler
  );
  yield takeLatest(
    MastersActions.ADD_SEND_NOTIFICATION_MASTER,
    addSendNotificationMastersHandler
  );
  yield takeLatest(
    MastersActions.GET_SUPPORT_MASTER_LIST,
    getSupportMastersHandler
  );
}
